(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/views/chat-bot.js') >= 0) return;  svs.modules.push('/modules/customer-service/views/chat-bot.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.customer_service=_svs.customer_service||{};
_svs.customer_service.templates=_svs.customer_service.templates||{};
svs.customer_service.templates.chat_bot = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"gutter-xs-1\">\n  <div class=\"f-content f-700 padding-bottom-1\">Chatta med vår digitala\n    assistent</div>\n  <p>\n    "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.chatBot : depth0)) != null ? stack1.botOpenTime : stack1), depth0))
    + "\n  </p>\n  <p>\n    <a class=\"padding-sm-1 js-open-chat\" href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.chatBot : depth0)) != null ? stack1.botLink : stack1), depth0))
    + "\" target=\"svs_chat\">\n      "
    + ((stack1 = (helpers.ui || (depth0 && depth0.ui) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"button",{"name":"ui","hash":{"class":"padding-xs-h-3","inverted":true,"size":300},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n    </a>\n  </p>\n</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.chatBot : depth0)) != null ? stack1.botLinkText : stack1), depth0));
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.blockHelperMissing.call(depth0,container.lambda(((stack1 = (depth0 != null ? depth0.chatBot : depth0)) != null ? stack1.hidden : stack1), depth0),{"name":"chatBot.hidden","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['svs-customer_service-chat_bot'] = svs.customer_service.templates.chat_bot;
})(svs, Handlebars);

 })(window);